import { registerMiddleware } from "@designbycosmic/cosmic-react-state-management";
import { gdpr } from "@utils";

const gdprCookieName = `${process.env.GATSBY_APP_NAME}_gdpr`;

const reducer = (state, action) => {
  let navVisibilty;
  switch (action.type) {
    case "startTransition":
      return {
        ...state,
        isTransitioning: true,
      };

    case "endTransition":
      return {
        ...state,
        isTransitioning: false,
      };

    case "acceptGdpr":
      return {
        ...state,
        gdpr: true,
      };

    case "hideNav":
      return {
        ...state,
        showNav: false,
      };

    case "showNav":
      return {
        ...state,
        showNav: true,
      };

    case "setPreviewMode":
      return {
        ...state,
        previewMode: action.previewMode,
      };

    default:
      return state;
  }
};

const { hasGdprConsent, setGdprConsent } = gdpr;

registerMiddleware({
  actionType: "acceptGdpr",
  func: () => {
    setGdprConsent(gdprCookieName);
  },
});

const initialState = {
  gdpr: hasGdprConsent(gdprCookieName),
  previewMode: false,
  isTransitioning: false,
  showNav: false,
};

const layout = {
  reducer,
  initialState,
};

export default layout;
